import { useState } from 'react';

import { OUTLINE_ACTION_STYLE } from './tree-replacement-styles';
import { TreeReplacementModal } from './TreeReplacementModal';

/** "Add replacement" and the add form it opens. `onOpen` lets the card switch to the
 *  Tree replacements tab so the new row is in view when the form closes. */
export function AddTreeReplacementButton({
  workshopId,
  onOpen,
}: {
  workshopId: string;
  onOpen: () => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        style={OUTLINE_ACTION_STYLE}
        onClick={() => {
          onOpen();
          setOpen(true);
        }}
      >
        Add replacement
      </button>
      {open && (
        <TreeReplacementModal
          workshopId={workshopId}
          view={{ mode: 'add' }}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
